module.exports = __webpack_public_path__ + "media/images/faq/brand4-ed30eef7c5bfd832077b8fe24e3fba1a.png";